import $ from 'jquery';
import jqueryValidation from 'jquery-validation';

export class Recipe_prescription {

    init(){



        /**
         *
         * Form Recept felírás
         *
         * */

        $("#recipe_prescription").on('click', function (e) {
            e.preventDefault();

            let form = $('#recipe_prescription_form');

            form.validate({
                groups: {
                    nameGroupRequest_recipe_prescription: "name email taj phone date birthday aszf privacy_policy"
                },
                rules: {
                    name: {
                        required: true
                    },
                    email: {
                        required: true
                    },
                    taj: {
                        required: true
                    },
                    phone: {
                        required: true,
                        number: true
                    },
                    date: {
                        required: true
                    },
                    birthday: {
                        required: true
                    },
                    aszf: {
                        required: true
                    },
                    privacy_policy: {
                        required: true
                    }
                },
                messages: {
                    name: {
                        required: "Minden mező kitöltése kötelező!"
                    },
                    email: {
                        required: "Minden mező kitöltése kötelező!",
                        email: "Nem megfelelő az email formátuma!"
                    },
                    phone: {
                        required: "Minden mező kitöltése kötelező!",
                        number: "A mező csak számokat tartalmazhat!"
                    },
                    birthday: {
                        required: "Minden mező kitöltése kötelező!"
                    },
                    date: {
                        required: "Minden mező kitöltése kötelező!"
                    },
                    taj: {
                        required: "Minden mező kitöltése kötelező!"
                    },
                    aszf: {
                        required: 'Általános Szerződési Feltételei kitöltése kötelező!'
                    },
                    privacy_policy: {
                        required: 'Adatvédelmi Tájékoztató kitöltése kötelező!'
                    },
                    nameGroupRequest_recipe_prescription: {
                        required: "Minden mező kitöltése kötelező!"
                    }
                }
            });

            let isValid = form.valid();
            if (isValid) {

                let data = {
                    phone: form.find("#phone").val(),
                    email: form.find("#email").val(),
                    taj: form.find("#taj").val(),
                    name: form.find("#name").val(),
                    date: form.find("#date").val(),
                    birthday: form.find("#birthday").val(),
                    note: form.find("#comment").val()
                };

                $.ajax({
                    type: 'POST',
                    url: ajaxurl,
                    dataType: 'json',
                    data: {
                        action: 'Request_recipe_prescription',
                        data: data

                    },
                    beforeSend: function () {
                        $("#panelsStayOpen-collapseRecipe_prescription #loading-image").show();
                        $("#recipe_prescription").prop('disabled', true);
                    },
                    success: function (res) {

                        $("#panelsStayOpen-collapseRecipe_prescription .box").fadeTo("slow", 0.00, function () { //fade
                            $(this).slideUp(1000, function () { //slide up
                                $(this).remove(); //then remove from the DOM
                                $("#panelsStayOpen-collapseRecipe_prescription .thank-you-text").removeClass("d-none");
                            });
                        });
                        $('html, body').animate({
                            scrollTop: $("#panelsStayOpen-collapseRecipe_prescription").offset().top + (-40)
                        }, 1500);
                    },
                    error: function (res) {
                        console.log("error" );
                        /* $(".valasz-oldal").removeClass("hidden-thank-you");*/
                    }

                });
            }
        });
    }
}


